@if (detailsPaymentForm) {
  <div [formGroup]="detailsPaymentForm">
    <div
      class="bg-white shadow-md text-2xl rounded-2xl px-8 py-4 mobile:px-4"
      formGroupName="details"
      >
      <div class="font-normal text-xl mb-4">Your Details</div>
      <div class="flex mobile:flex-col">
        <div class="mr-4">
          <div class="text-base text-gray-600">First Name</div>
          <mat-form-field appearance="outline" class="w-52">
            <input matInput formControlName="firstName" />
            <!-- <mat-error>Please enter a name</mat-error> -->
          </mat-form-field>
        </div>
        <div>
          <div class="text-base text-gray-600">Surname</div>
          <mat-form-field appearance="outline" class="w-52">
            <input matInput formControlName="surname" />
            <!-- <mat-error>Please enter a surname</mat-error> -->
          </mat-form-field>
        </div>
      </div>
      <div class="flex">
        <div class="mr-4">
          <div class="text-base text-gray-600">Email</div>
          <mat-form-field appearance="outline" class="w-80">
            <input matInput formControlName="email" />
            <!-- <mat-error>Please enter a valid email</mat-error> -->
          </mat-form-field>
        </div>
      </div>
      <div class="flex mobile:flex-col">
        <div class="mr-4">
          <div class="text-base text-gray-600">Mobile Phone</div>
          <mat-form-field appearance="outline" class="w-48">
            <input matInput formControlName="mobilePhone" />
            <!-- <mat-error>Please enter a phone number</mat-error> -->
          </mat-form-field>
        </div>
        <!-- <div>
        <div class="text-base text-gray-600">Student ID</div>
        <mat-form-field class="w-40">
          <input matInput formControlName="studentId">
          <mat-error>Please enter a student ID</mat-error>
        </mat-form-field>
      </div> -->
    </div>
  </div>
  <div
    class="bg-white shadow-md text-2xl rounded-2xl mt-4 px-8 py-4 mobile:px-4"
    formGroupName="address"
    >
    <div class="font-normal text-xl mb-4">Your Address</div>
    <div class="flex w-full">
      <div class="mr-4 w-full">
        <div class="text-base text-gray-600">Address</div>
        <mat-form-field appearance="outline" class="w-3/4 mobile:w-full">
          <input matInput formControlName="address" />
        </mat-form-field>
      </div>
    </div>
    <div class="flex w-full">
      <div class="mr-4 w-full">
        <mat-form-field appearance="outline" class="w-3/4 mobile:w-full">
          <input matInput formControlName="address2" />
        </mat-form-field>
      </div>
    </div>
    <div class="flex mobile:flex-col w-full">
      <div class="mr-4">
        <div class="text-base text-gray-600">City</div>
        <mat-form-field appearance="outline" class="w-80 mobile:w-full">
          <input matInput formControlName="city" />
        </mat-form-field>
      </div>
      <div class="mr-4">
        <div class="text-base text-gray-600">Postcode</div>
        <mat-form-field appearance="outline" class="w-32">
          <input matInput formControlName="postcode" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="font-normal text-xl mt-4">
    Agreements (Click each statement to agree)
  </div>
  <div formArrayName="agreements">
    @for (agreementKey of agreementKeys; track agreementKey; let i = $index) {
      <div
        class="agreement-cont bg-white text-base items-center rounded-2xl mb-4 mt-2 px-8 py-4 flex cursor-pointer hover:bg-gray-100 hover:border-gray-100"
        [ngClass]="{ 'is-invalid': agreementIsInvalid(agreementKey) }"
        (click)="toggleAgreement(agreementKey)"
        >
        @switch (agreementKey) {
          @case ('agreementCollection') {
            <div class="flex items-center mr-4">
              <div class="w-8">
                <fa-icon
                  class="text-3xl transition-all"
                  [ngClass]="isAgreementTrue('agreementCollection') ? 'text-green-500' : 'text-gray-300'"
                  [icon]="['fas', 'check-circle']"
                ></fa-icon>
              </div>
            </div>
            <div>
              <div class="font-medium">Pick up & Drop off</div>
              <div [innerHtml]="getAgreementText('agreementCollection')"></div>
            </div>
          }
          @case ('agreementLateFee') {
            <div class="flex items-center mr-4">
              <div class="w-8">
                <fa-icon
                  class="text-3xl transition-all"
                  [ngClass]="isAgreementTrue('agreementLateFee') ? 'text-green-500' : 'text-gray-300'"
                  [icon]="['fas', 'check-circle']"
                ></fa-icon>
              </div>
            </div>
            <div>
              <div class="font-medium">Late Fee</div>
              <div [innerHTML]="getAgreementText('agreementLateFee')"></div>
            </div>
          }
          @case ('agreementTerms') {
            <div class="flex items-center mr-4">
              <div class="w-8">
                <fa-icon
                  class="text-3xl transition-all"
                  [ngClass]="isAgreementTrue('agreementTerms') ? 'text-green-500' : 'text-gray-300'"
                  [icon]="['fas', 'check-circle']"
                ></fa-icon>
              </div>
            </div>
            <div>
              <div class="font-medium">Terms & Conditions</div>
              <div>
                You agree to the general
                <a
                  class="text-gwc-primary-red hover:underline"
                  (click)="termsAndConditionsClicked($event)"
                  >Terms & FAQs</a
                  >.
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
    <!-- TODO: Add image to dashboard in casual hires by week -->
    <div
      class="bg-white shadow-md text-xl rounded-2xl mt-8 px-8 py-4 mobile:px-4 agreement-cont"
      [ngClass]="{ 'is-invalid': isFileNotUploaded() }"
      >
      <form formGroupName="qualification">
        <div class="font-normal text-xl mb-4">Qualification Upload</div>
        <div class="font-medium mb-4">
          To hire regalia we must have proof your qualification has been conferred
          (made legal) by your institution. Please upload proof yours has been.
        </div>
        <div class="mt-4 p-4 border-2 border-dashed border-gray-300 rounded-lg text-center">
          <input
            #fileInput
            type="file"
            accept=".png"
            (change)="onFileSelected($event)"
            hidden
          />
          <div class="flex items-center justify-center">
            <div class="drop-cont mt-2">
              Select an image of your qualification -or-
            </div>
            <div class="browse-cont ml-4">
              <button
                mat-flat-button
                type="button"
                (click)="fileInput.click()"
              >
                Browse Files
              </button>
            </div>
          </div>
        </div>
        @if (qualificationImage) {
          <div class="text-base mt-4 pl-4">
            <div class="flex space-x-4">
              <div class="text-gray-400">Filename:</div>
              <div>{{ qualificationImage.file.name }}</div>
              <div class="w-12"></div>
              <div class="text-gray-400">Image Type</div>
              <div>{{ qualificationImage.file.type }}</div>
            </div>
          </div>
        }
        <br />
        @if (isFileNotUploaded()) {
          <div>Qualification image is required.</div>
        }
      </form>
    </div>
    <div
      class="stripe-fields-container bg-white shadow-md text-2xl rounded-2xl mt-8 px-8 py-4 mobile:px-4"
      formGroupName="credit"
      >
      <div class="font-normal text-xl mb-4">Got a credit?</div>
      <div class="flex mobile:flex-col space-x-4 mobile:space-x-0 mobile:space-y-4">
        <div class="flex">
          <div>
            <div class="text-base text-gray-600">Please enter your code</div>
            <mat-form-field appearance="outline" class="w-60 mobile:w-full fuse-mat-dense fuse-mat-no-subscript">
              <input matInput formControlName="credit_code" />
            </mat-form-field>
          </div>
        </div>
        @if (!creditCheckStatus) {
          <div>
            <div class="text-base text-gray-600">&nbsp;</div>
            <button
              mat-stroked-button
              color="primary"
              [disabled]="creditCheckLoading"
              (click)="checkCreditCode()"
              >
              @if (!creditCheckLoading) {
                Check
              } @else {
                <mat-spinner diameter="20"></mat-spinner>
              }
            </button>
          </div>
        }
      </div>
      @if (creditCheckStatus === false) {
        <div class="text-base">
          <div>Code is not valid. Please try again</div>
        </div>
      }
      @if (creditCheckStatus) {
        <div class="text-base">
          <div>Code is valid.</div>
        </div>
      }
    </div>
    <div
      class="stripe-fields-container bg-white shadow-md text-2xl rounded-2xl mt-8 px-8 py-4 mobile:px-4"
      formGroupName="creditCard"
      >
      <div class="font-normal text-xl mb-4">Credit Card Details</div>
      <div class="flex">
        <div>
          <div class="text-base text-gray-600">Name on card</div>
          <mat-form-field appearance="outline" class="w-60">
            <input matInput formControlName="name" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex w-full mb-8 mobile:flex-col" #stripeContainer>
        <div class="mr-4">
          <div class="text-base text-gray-600">Card number</div>
          <div
            id="stripe-card-number"
            class="stripe-input"
            class="w-80 mobile:w-full"
          ></div>
        </div>
        <div class="mr-4">
          <div class="text-base text-gray-600">Expiry</div>
          <div id="stripe-card-expiry" class="stripe-input"></div>
        </div>
        <div class="mr-4">
          <div class="text-base text-gray-600">CVC code</div>
          <div id="stripe-card-cvc" class="stripe-input"></div>
        </div>
      </div>
    </div>
  </div>
}
